<script>
    import {CART_VIEW, FAMILY_PRICE, FAMILY_DISCOUNTED_PRICE, TICKET_CODES} from './lib/constants';
    import app from "./stores/app";
    import CartHeader from "./cart/CartHeader.svelte";
    import CartStep1 from "./cart/el/CartStep1.svelte";
    import CartStep2 from "./cart/CartStep2.svelte";
    import CartStep3 from "./cart/CartStep3.svelte";

    let cartView = CART_VIEW.TICKETS;

    const gotoTickets = () => {
        cartView = CART_VIEW.TICKETS;
        $app.cartStep = 1;
    };

    const initialize = () => {
        let GROUPS = $app.GROUPS;
        let TICKETS = $app.TICKETS;
        let product;

        // Set default tickets class
        $app.ticket_discount_id = GROUPS.GREEK.id;

        // set the tickets
        // FAMILY
        // REMOVED FOR 2026
        // product = {
        //     id: 10,
        //     code: TICKET_CODES.FAMILY,
        //     name: "Οικογενειακό Πακέτο",
        //     admissionTitle: 'Περιλαμβάνει 2 εισιτήρια ενηλίκων και 2 εισιτήρια παιδιών',
        //     personsLabel: 'Αρ. εισιτηρίων',
        //     minPersons: 0,
        //     maxPersons: 1,
        //     persons: 0,
        //     totalPrice: 0,
        //     icon: 'family',
        //     classes: [
        //         {
        //             id: GROUPS.FAMILY.id,
        //             code: 'FAMILY',
        //             title: '',
        //             price: FAMILY_PRICE,
        //             discounted_price: FAMILY_DISCOUNTED_PRICE.toFixed(2),
        //
        //             rules: [
        //                 "Πρόσβαση στα παιχνίδια βάσει ύψους",
        //             ],
        //             games: [],
        //         }
        //     ]
        // }
        // $app.products.push(product);

        // ADULTS
        product = {
            id: TICKETS.ADULT.id,
            code: TICKETS.ADULT.code,
            name: "Ενήλικες",
            admissionTitle: 'Γενική Είσοδος',
            personsLabel: 'Αρ. ενηλίκων',
            minPersons: 1,
            maxPersons: 9,
            persons: 1,
            totalPrice: 0,
            icon: 'adult',
            classes: [
                {
                    id: GROUPS.GREEK.id,
                    code: 'GREEK',
                    title: '',
                    price: GROUPS.GREEK.tickets.ADULT.original_price,
                    discounted_price: "16.50", //GROUPS.GREEK.tickets.ADULT.price,

                    rules: [
                        "Πρόσβαση σε όλα τα παιχνίδια",
                    ],
                    games: ['kids', 'advanced', 'xtreme'],
                }
            ]
        }
        $app.products.push(product);

        // CHILDREN
        product = {
            id: TICKETS.CHILD.id,
            code: TICKETS.CHILD.code,
            name: "Παιδιά",
            admissionTitle: 'Ύψος κάτω από 1,40μ',
            personsLabel: 'Αρ. παιδιών',
            minPersons: 0,
            maxPersons: 9,
            persons: 0,
            totalPrice: 0,
            icon: 'child',
            classes: [
                {
                    id: GROUPS.GREEK.id,
                    code: 'GREEK',
                    title: '',
                    price: GROUPS.GREEK.tickets.CHILD.original_price,
                    discounted_price: "11.00", //GROUPS.GREEK.tickets.CHILD.price,

                    rules: [
                        "Πρόσβαση στα εύκολα και μεσαία παιχνίδια",
                    ],
                    games: ['kids', 'advanced'],
                },
            ]
        }
        $app.products.push(product);

        // TODDLER
        product = {
            id: TICKETS.INFANT.id,
            code: TICKETS.INFANT.code,
            name: "Νήπια",
            admissionTitle: 'Ελεύθερη είσοδος',
            personsLabel: 'Αρ. νηπίων',
            minPersons: 0,
            maxPersons: 9,
            persons: 0,
            totalPrice: 0,
            icon: 'toddler',
            classes: [
                {
                    id: GROUPS.GREEK.id,
                    code: 'GREEK',
                    title: '',
                    price: 0,
                    discounted_price: 0,
                    rules: [],
                    games: [],
                },
            ]
        }
        $app.products.push(product);

        $app.cartStep = 1;
    }

    initialize();
</script>

<CartHeader/>
<div class="cart-container">
    {#if $app.cartStep == 1}
        <CartStep1/>
    {:else if $app.cartStep == 2}
        <CartStep2/>
    {:else}
        <CartStep3/>
    {/if}
</div>